import React from 'react';
import {
    Card,
    List,
    ListItem,
    Typography
  } from '@material-ui/core';
import moment from 'moment'


const FileModal = ({ metadata, name, onClose, fileType, fileUrl, uploadedBy, uploadDate, fullName }) => {
    return (
      <div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr', height: '90vh', width: '80vw', gap: '0.75rem' }}>
        <div
          style={{
            backgroundColor: 'rgba(0,0,0,0.4)',
            overflowY: 'auto',
            overflowX: 'auto',
            textAlign: 'center',
            width: '100%',
            height: '90vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {fileType == 'pdf' ? 
            <iframe src={fileUrl} style={{width: '100%', height: '90vh', borderWidth: 0}} /> : 
            <img src={fileUrl} style={{
              maxWidth: '100%',
              maxHeight: '90vh'
            }} />
          }
        
        </div>

        <div>
          <Card style={{ width: '100%', height: '90vh', overflowY: 'auto'}}>
          {/* minWidth: '30vw', maxWidth: '30vw', height: '98vh', overflowY: 'auto'  */}
            <div style={{ padding: '2rem', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: '90%' }}>
              {/* <Typography style={{ color: 'grey' }} variant="h6">
                {name}
              </Typography> */}

              {metadata ? (
                <>
                  <div style={{ }}>
                    {metadata?.map((data, j) => (
                      <div key={j} style={{ marginBottom: '0.5rem' }}>
                        <span style={{display:'block', fontSize: '0.75rem', lineHeight:'0.5rem', color: '#606668'}}>{data.label}</span>
                        <span style={{display:'block', fontWeight:'bold', color: '#606668', wordWrap: 'break-word'}}>{data.value}</span>
                      </div>
                    ))}{' '}
                  </div>
                  <div>
                    { uploadedBy && <div style={{ marginBottom: '0.5rem' }}>
                      <span style={{display:'block', fontSize: '0.75rem', lineHeight:'0.5rem', color: '#606668'}}>Subido por: </span>
                      <span style={{display:'block', fontWeight:'bold', color: '#606668', wordWrap: 'break-word'}}>{uploadedBy}</span>
                      <span style={{display:'block', fontWeight:'bold', color: '#606668', wordWrap: 'break-word'}}>{fullName}</span>
                    </div> }
                    <div style={{ marginBottom: '0.5rem' }}>
                      <span style={{display:'block', fontSize: '0.75rem', lineHeight:'0.5rem', color: '#606668'}}>Subido: </span>
                      {/* Subido hace 1 hora */}
                      {/* <span style={{display:'block', fontWeight:'bold', color: '#606668', wordWrap: 'break-word'}}>{moment(uploadDate).fromNow()}</span> */}
                      {/* Subido: 28 de Marzo de 2025 */}
                      {/* <span style={{display:'block', fontWeight:'bold', color: '#606668', wordWrap: 'break-word'}}>{moment(uploadDate).format('LL')}</span> */}
                      {/* Subido: 28/3/2025 */}
                      <span style={{display:'block', fontWeight:'bold', color: '#606668', wordWrap: 'break-word'}}>{moment(uploadDate).format('L') + ' (' + (moment(uploadDate).fromNow()) + ')'}</span>
                    </div>
                  </div>
                </>
              ) : (
                <Typography variant="p" style={{ color: 'grey' }}>
                  <i>No hay metadatos para mostrar</i>
                </Typography>
              )}
            </div>
          </Card>
        </div>
      </div>
    );
  };

  export default FileModal;